/* Wycena projektu (sections/main-quote.liquid).
   - „+ Dodaj wzor" otwiera okno z wyszukiwarka i siatka wzorow ze zdjeciami;
     klikniecie kafla zaznacza albo odznacza wzor i od razu dodaje/zdejmuje
     chip pod etykieta. × na chipie tez odznacza. Wybrane nazwy ida do
     jednego ukrytego pola formularza. Adres ?wzor=uchwyt,uchwyt wybiera
     wzory od razu (na przyszlosc: odnosnik ze strony wzoru).
   - Szacowana liczba plyt = powierzchnia scian / powierzchnia plyty, w gore.
   - Dostawa pokazuje pola adresu, odbior osobisty - wybor magazynu; pola
     niewybranej opcji sa schowane i wylaczone (nie ida do sklepu i nie sa
     wymagane). Tak samo adres klienta (schowany, gdy taki sam jak adres
     dostawy) i NIP (tylko dla firmy).
   - Zalaczniki (gdy sekcja ma adres uslugi wycen i klucz Turnstile): lista
     plikow z miniaturami, captcha Cloudflare Turnstile, a wysylka idzie w DWOCH
     krokach - najpierw cale zapytanie z plikami do Workera (zwraca numer), potem
     zwykly formularz kontaktowy z tym numerem, wiec mail do sklepu zostaje.
     Awaria uslugi = komunikat i przycisk „Wyslij bez zalacznikow”.
   Wszystkie zdarzenia wisza na samym elemencie, wiec przezywaja podmiane
   sekcji w edytorze motywu (customElements wola connectedCallback na nowo). */
(function () {
  if (customElements.get('project-quote')) return;

  const bezZnakow = (s) =>
    String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ł/g, 'l');

  class ProjectQuote extends HTMLElement {
    connectedCallback() {
      if (this.uzbrojony) return;
      this.uzbrojony = true;

      this.chipy = this.querySelector('[data-quote-chips]');
      this.poleWzorow = this.querySelector('[data-quote-patterns]');
      this.szablon = this.querySelector('[data-quote-chip-tpl]');
      this.okno = this.querySelector('[data-quote-picker]');
      this.szukaj = this.querySelector('[data-quote-search]');
      this.pusto = this.querySelector('[data-quote-empty]');
      this.kafle = [...this.querySelectorAll('[data-quote-tile]')];
      this.powierzchnia = this.querySelector('[data-quote-area]');
      this.szacunek = this.querySelector('[data-quote-estimate]');
      this.poleSzacunku = this.querySelector('[data-quote-estimate-field]');
      this.przycisk = this.querySelector('[data-quote-submit]');
      this.formularz = this.querySelector('form');
      this.usluga = (this.dataset.service || '').replace(/\/$/, '');
      this.sitekey = this.dataset.sitekey || '';
      // Czas od otwarcia mierzymy zegarem strony (performance.now), nie zegarem
      // telefonu - przestawiony zegar albo karta otwarta od wczoraj nie robi z
      // czlowieka bota.
      this.otwarto = performance.now();
      this.pliki = [];
      this.wejscie = this.querySelector('[data-quote-files-input]');
      this.listaPlikow = this.querySelector('[data-quote-files-list]');
      this.bladPlikow = this.querySelector('[data-quote-files-error]');
      this.szablonPliku = this.querySelector('[data-quote-file-tpl]');
      this.blad = this.querySelector('[data-quote-error]');

      const plyta = parseFloat(String(this.dataset.panelArea || '').replace(',', '.'));
      this.plyta = plyta > 0 ? plyta : 3.416;
      this.reguly = new Intl.PluralRules(document.documentElement.lang || 'pl');

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-quote-delivery], [data-quote-same]')) this.dostawa();
        else if (e.target.matches('[name="contact[Rodzaj klienta]"]')) this.rodzaj();
        else if (e.target === this.wejscie) {
          this.dodajPliki([...this.wejscie.files]);
          this.wejscie.value = '';
        }
      });
      const strefa = this.querySelector('[data-quote-drop]');
      if (strefa) {
        ['dragenter', 'dragover'].forEach((typ) =>
          strefa.addEventListener(typ, (e) => {
            e.preventDefault();
            strefa.classList.add('is-nad');
          }),
        );
        ['dragleave', 'drop'].forEach((typ) => strefa.addEventListener(typ, () => strefa.classList.remove('is-nad')));
        strefa.addEventListener('drop', (e) => {
          e.preventDefault();
          if (e.dataTransfer) this.dodajPliki([...e.dataTransfer.files]);
        });
      }
      this.addEventListener('input', (e) => {
        if (e.target === this.powierzchnia) this.policz();
        else if (e.target === this.szukaj) this.filtruj();
      });
      this.addEventListener('click', (e) => {
        const cel = e.target;
        const usunPlik = cel.closest('.quote-file__remove');
        if (usunPlik) return this.usunPlik(usunPlik.closest('.quote-file'));
        if (cel.closest('[data-quote-without]')) return this.wyslijBezPlikow();
        const usun = cel.closest('.quote-chip__remove');
        if (usun) return this.usunWzor(usun.closest('.quote-chip').dataset.value, true);
        if (cel.closest('[data-quote-open]')) return this.otworz();
        if (cel.closest('[data-quote-close]')) return this.zamknij();
        const kafel = cel.closest('[data-quote-tile]');
        if (kafel) return this.przelacz(kafel);
        // Klikniecie w zaciemnienie (sam <dialog>, poza panelem) zamyka okno.
        if (cel === this.okno) this.zamknij();
      });
      if (this.okno) this.okno.addEventListener('close', () => this.poZamknieciu());
      /* Wysylke lapiemy na OKNIE w fazie przechwytywania - zanim dostanie ja
         ktokolwiek na samym formularzu. Skrypt antyspamowy Shopify (hCaptcha)
         podpina sie WPROST pod formularz i od razu wysyla go natywnie; stopPropagation
         go nie zatrzymywal, wiec strona przechodzila na wyzwanie captchy w trakcie
         wgrywania plikow i usluga zrywala zapytanie - wycena bez zalacznikow
         (zmierzone 26.10.2026: status 'canceled' w dzienniku uslugi). */
      if (this.formularz) {
        window.addEventListener('submit', (e) => {
          if (e.target === this.formularz && this.isConnected) this.wysylka(e);
        }, true);
      }
      if (this.usluga && this.sitekey) this.captchaZaladuj();

      this.wczytajZAdresu();
      this.policz();
      this.dostawa();
      this.rodzaj();
      // Przegladarka przywraca zaznaczenia po przeladowaniu i powrocie wstecz
      // PO starcie elementu i bez zdarzenia change - przeliczamy jeszcze raz.
      window.addEventListener('pageshow', () => {
        this.dostawa();
        this.rodzaj();
      });

      const status = this.querySelector('[data-quote-status]');
      if (status) {
        // Numer z pierwszego kroku wysylki przezywa przeladowanie po formularzu.
        const numer = sessionStorage.getItem('dizz_wycena_numer');
        if (numer && status.classList.contains('form-status--success') && this.przycisk) {
          const linia = document.createElement('span');
          linia.className = 'quote__status-number';
          linia.textContent = this.przycisk.dataset.successNumber.replace('__NUMER__', numer);
          status.append(linia);
        }
        sessionStorage.removeItem('dizz_wycena_numer');
        status.scrollIntoView({ block: 'center' });
      }
    }

    /* ---------- okno wyboru ---------- */

    otworz() {
      if (!this.okno || this.okno.open) return;
      this.okno.showModal();
      if (window.dizzBlokadaTla) window.dizzBlokadaTla.zablokuj();
      this.zablokowane = true;
      // Na telefonie klawiatura zaslonilaby pol okna - fokus tylko od 990 px.
      if (this.szukaj && window.matchMedia('(min-width: 990px)').matches) this.szukaj.focus();
    }

    zamknij() {
      if (this.okno && this.okno.open) this.okno.close();
    }

    poZamknieciu() {
      this.synchronizujChipy();
      if (this.zablokowane && window.dizzBlokadaTla) window.dizzBlokadaTla.odblokuj();
      this.zablokowane = false;
      if (this.szukaj && this.szukaj.value) {
        this.szukaj.value = '';
        this.filtruj();
      }
      const otworz = this.querySelector('[data-quote-open]');
      if (otworz) otworz.focus();
    }

    filtruj() {
      const fraza = bezZnakow(this.szukaj.value.trim());
      let widoczne = 0;
      this.kafle.forEach((kafel) => {
        const pasuje = !fraza || bezZnakow(kafel.dataset.value).includes(fraza);
        kafel.parentElement.hidden = !pasuje;
        if (pasuje) widoczne += 1;
      });
      if (this.pusto) this.pusto.hidden = widoczne > 0;
    }

    // Klik w oknie zmienia TYLKO kafel. Chipy pod oknem dochodza dopiero po
    // zamknieciu - kazdy chip dokladany od razu przesuwal strone widoczna przez
    // polprzezroczyste tlo i wygladalo to jak przeladowanie przy kazdym kliknieciu.
    przelacz(kafel) {
      kafel.setAttribute('aria-pressed', kafel.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    }

    synchronizujChipy() {
      this.kafle.forEach((kafel) => {
        const wybrany = kafel.getAttribute('aria-pressed') === 'true';
        const chip = this.chip(kafel.dataset.value);
        if (wybrany && !chip) this.dodajWzor(kafel);
        else if (!wybrany && chip) chip.remove();
      });
      this.zapiszWzory();
    }

    /* ---------- chipy ---------- */

    dodajWzor(kafel) {
      if (!this.szablon || this.chip(kafel.dataset.value)) return;
      const chip = this.szablon.content.firstElementChild.cloneNode(true);
      chip.dataset.value = kafel.dataset.value;
      chip.querySelector('.quote-chip__name').textContent = kafel.dataset.value;
      const img = chip.querySelector('img');
      if (kafel.dataset.image) img.src = kafel.dataset.image;
      else img.remove();
      const usun = chip.querySelector('.quote-chip__remove');
      usun.setAttribute('aria-label', usun.dataset.label.replace('__NAZWA__', kafel.dataset.value));
      this.chipy.insertBefore(chip, this.chipy.lastElementChild);
      kafel.setAttribute('aria-pressed', 'true');
      this.zapiszWzory();
    }

    usunWzor(wartosc, fokus) {
      const chip = this.chip(wartosc);
      if (chip) chip.remove();
      const kafel = this.kafle.find((k) => k.dataset.value === wartosc);
      if (kafel) kafel.setAttribute('aria-pressed', 'false');
      this.zapiszWzory();
      if (fokus) {
        const otworz = this.querySelector('[data-quote-open]');
        if (otworz) otworz.focus();
      }
    }

    chip(wartosc) {
      return [...this.chipy.querySelectorAll('.quote-chip[data-value]')].find((c) => c.dataset.value === wartosc);
    }

    zapiszWzory() {
      if (!this.poleWzorow) return;
      this.poleWzorow.value = [...this.chipy.querySelectorAll('.quote-chip[data-value]')]
        .map((c) => c.dataset.value)
        .join(', ');
    }

    wczytajZAdresu() {
      const uchwyty = (new URLSearchParams(location.search).get('wzor') || '')
        .split(',')
        .map((u) => u.trim())
        .filter(Boolean);
      uchwyty.forEach((uchwyt) => {
        const kafel = this.kafle.find((k) => k.dataset.handle === uchwyt);
        if (kafel) this.dodajWzor(kafel);
      });
    }

    /* ---------- szacunek, dostawa, wysylka ---------- */

    policz() {
      if (!this.powierzchnia || !this.szacunek) return;
      const m2 = parseFloat(String(this.powierzchnia.value).replace(',', '.'));
      if (!(m2 > 0)) {
        this.szacunek.textContent = '-';
        if (this.poleSzacunku) this.poleSzacunku.value = '';
        return;
      }
      const n = Math.ceil(m2 / this.plyta - 1e-9);
      const wzor = this.szacunek.dataset[this.reguly.select(n)] || this.szacunek.dataset.other;
      this.szacunek.textContent = wzor.replace('__N__', n);
      if (this.poleSzacunku) this.poleSzacunku.value = String(n);
    }

    dostawa() {
      // Kazda opcja z dodatkowymi polami (adres, wybor magazynu) pokazuje je
      // tylko, gdy jest zaznaczona; ukryte pola sa WYLACZONE, wiec nie ida do
      // sklepu i nie sa wymagane.
      this.querySelectorAll('[data-quote-delivery]').forEach((radio) => {
        const grupa = radio.closest('.quote-option--group');
        const extra = grupa && grupa.querySelector('[data-quote-extra]');
        if (!extra) return;
        extra.hidden = !radio.checked;
        extra.querySelectorAll('input').forEach((pole) => {
          pole.disabled = !radio.checked;
        });
      });

      // Adres klienta: przy dostawie domyslnie taki sam jak adres dostawy
      // (pola schowane i wylaczone); przy odbiorze checkboxa nie ma, wiec
      // adres trzeba wpisac.
      const dostawa = this.querySelector('[data-quote-delivery]:checked');
      const zDostawa = !!dostawa && !dostawa.value.toLowerCase().startsWith('odbi');
      const taki = this.querySelector('[data-quote-same]');
      const wiersz = this.querySelector('[data-quote-same-row]');
      const pola = this.querySelector('[data-quote-address-fields]');
      if (!taki || !pola) return;
      wiersz.hidden = !zDostawa;
      taki.disabled = !zDostawa;
      const wpisz = !zDostawa || !taki.checked;
      pola.hidden = !wpisz;
      pola.querySelectorAll('input').forEach((pole) => {
        pole.disabled = !wpisz;
      });
    }

    rodzaj() {
      // NIP tylko dla firmy - przy kliencie indywidualnym pole schowane i wylaczone.
      const firma = this.querySelector('[name="contact[Rodzaj klienta]"]:checked');
      const czyFirma = !!firma && firma.value !== 'Klient indywidualny';
      this.querySelectorAll('[data-quote-company]').forEach((blok) => {
        blok.hidden = !czyFirma;
        blok.querySelectorAll('input').forEach((pole) => {
          pole.disabled = !czyFirma;
        });
      });
    }

    /* ---------- zalaczniki ---------- */

    dodajPliki(nowe) {
      if (!this.listaPlikow || !this.szablonPliku) return;
      const LIMIT = 5;
      const ROZMIAR = 10 * 1024 * 1024;
      const DOZWOLONE = /\.(jpe?g|png|webp|heic|heif|pdf)$/i;
      const komunikaty = [];
      const d = this.przycisk.dataset;
      for (const plik of nowe) {
        if (this.pliki.length >= LIMIT) {
          komunikaty.push(d.filesTooMany);
          break;
        }
        if (!DOZWOLONE.test(plik.name) && !/^(image\/(jpeg|png|webp|heic|heif)|application\/pdf)$/.test(plik.type)) {
          komunikaty.push(d.filesBadType.replace('__NAZWA__', plik.name));
          continue;
        }
        if (plik.size > ROZMIAR) {
          komunikaty.push(d.filesTooBig.replace('__NAZWA__', plik.name));
          continue;
        }
        this.pliki.push(plik);
        this.rysujPlik(plik);
      }
      this.pokazBladPlikow(komunikaty.join(' '));
    }

    rysujPlik(plik) {
      const el = this.szablonPliku.content.firstElementChild.cloneNode(true);
      el.plik = plik;
      const media = el.querySelector('.quote-file__media');
      /* Miniatura tylko dla formatow, ktore przegladarka umie narysowac; HEIC
         (zdjecie z iPhone'a wyslane z komputera) i PDF dostaja napis z
         rozszerzeniem - Chrome rysowal przy HEIC pusty obrazek, a gdy nie znal
         typu pliku, wychodzilo „PDF” (26.10.2026). */
      const rozszerzenie = (plik.name.split('.').pop() || '').toUpperCase();
      const napis = () => {
        media.textContent = rozszerzenie === 'JPEG' ? 'JPG' : rozszerzenie.slice(0, 4) || (plik.type === 'application/pdf' ? 'PDF' : '');
      };
      if (/^image\/(jpeg|png|webp)$/.test(plik.type)) {
        const img = document.createElement('img');
        img.alt = '';
        img.width = 40;
        img.height = 40;
        img.src = URL.createObjectURL(plik);
        el.adres = img.src;
        img.onerror = () => {
          img.remove();
          napis();
        };
        media.append(img);
      } else {
        napis();
      }
      el.querySelector('.quote-file__name').textContent = plik.name;
      const mb = plik.size / 1024 / 1024;
      el.querySelector('.quote-file__size').textContent =
        mb >= 1 ? `${mb.toFixed(1).replace('.', ',')} MB` : `${Math.max(1, Math.round(plik.size / 1024))} kB`;
      const usun = el.querySelector('.quote-file__remove');
      usun.setAttribute('aria-label', usun.dataset.label.replace('__NAZWA__', plik.name));
      this.listaPlikow.append(el);
    }

    usunPlik(el) {
      if (!el) return;
      this.pliki = this.pliki.filter((p) => p !== el.plik);
      if (el.adres) URL.revokeObjectURL(el.adres);
      el.remove();
      this.pokazBladPlikow('');
      if (this.wejscie) this.wejscie.focus();
    }

    pokazBladPlikow(tekst) {
      if (!this.bladPlikow) return;
      this.bladPlikow.textContent = tekst;
      this.bladPlikow.hidden = !tekst;
    }

    /* ---------- captcha ---------- */

    captchaZaladuj() {
      const rysuj = () => {
        const miejsce = this.querySelector('[data-quote-captcha]');
        if (!miejsce || this.captchaId !== undefined || !window.turnstile) return;
        try {
          this.captchaId = window.turnstile.render(miejsce, {
            sitekey: this.sitekey,
            action: 'wycena',
            language: document.documentElement.lang || 'auto',
            appearance: 'interaction-only',
            'error-callback': () => {
              this.captchaPadla = true;
            },
          });
        } catch (blad) {
          this.captchaPadla = true;
        }
      };
      if (window.turnstile) return rysuj();
      window.dizzTurnstileGotowy = window.dizzTurnstileGotowy || [];
      window.dizzTurnstileGotowy.push(rysuj);
      if (document.querySelector('script[data-dizz-turnstile]')) return;
      window.dizzTurnstileStart = () => (window.dizzTurnstileGotowy || []).forEach((f) => f());
      const skrypt = document.createElement('script');
      skrypt.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=dizzTurnstileStart';
      skrypt.async = true;
      skrypt.defer = true;
      skrypt.dataset.dizzTurnstile = '';
      // Bloker reklam albo firmowy filtr potrafi zablokowac skrypt captchy -
      // wtedy klient wysyla zwykly formularz (bez plikow), a nie trafia na mur.
      skrypt.onerror = () => {
        this.captchaPadla = true;
      };
      document.head.append(skrypt);
    }

    captchaToken() {
      if (!window.turnstile || this.captchaId === undefined) return '';
      return window.turnstile.getResponse(this.captchaId) || '';
    }

    /* ---------- wysylka ---------- */

    wysylka(e) {
      if (!this.przycisk) return;
      // Bez uslugi albo po pierwszym kroku idzie zwykly formularz kontaktowy.
      if (!this.usluga || this.krokPierwszyZrobiony) return this.zablokujPrzycisk();
      // Captcha sie nie zaladowala: zwykly formularz z dopiskiem o plikach.
      if (this.captchaPadla || (!window.turnstile && performance.now() - this.otwarto > 15000)) {
        const zalaczniki = this.formularz.querySelector('[data-quote-attachments]');
        if (zalaczniki) zalaczniki.value = this.pliki.length ? `${this.pliki.length} - NIE DOTARLY (captcha sie nie zaladowala), poprosic klienta o maila` : 'brak';
        return this.zablokujPrzycisk();
      }
      // Shopify ma na dokumencie wlasny skrypt antyspamowy formularzy kontaktowych:
      // przy wysylce zapisuje stan pol i OD RAZU wysyla formularz - bez numeru
      // wyceny, ktorego jeszcze nie ma. Pierwsze klikniecie nie moze do niego dojsc.
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.wysylam) return;
      this.wyslijDoUslugi();
    }

    zablokujPrzycisk() {
      this.przycisk.disabled = true;
      if (this.przycisk.dataset.sending) this.przycisk.textContent = this.przycisk.dataset.sending;
    }

    pokazBlad(tekst, bezPlikow) {
      if (!this.blad) return;
      this.blad.hidden = !tekst;
      this.blad.querySelector('[data-quote-error-text]').textContent = tekst || '';
      const przycisk = this.blad.querySelector('[data-quote-without]');
      if (przycisk) przycisk.hidden = !bezPlikow;
    }

    zbierz() {
      const f = this.formularz;
      const wartosc = (nazwa) => {
        const pole = f.querySelector(`[name="${nazwa}"]:not(:disabled)`);
        if (!pole) return '';
        if (pole.type === 'radio') {
          const zaznaczone = f.querySelector(`[name="${nazwa}"]:checked:not(:disabled)`);
          return zaznaczone ? zaznaczone.value : '';
        }
        if (pole.type === 'checkbox') return pole.checked ? pole.value : '';
        return pole.value;
      };
      const uslugi = [...f.querySelectorAll('.quote-step input[type="checkbox"]:checked:not([data-quote-same])')]
        .map((p) => p.name.replace(/^contact\[|\]$/g, ''))
        .join(', ');
      const dane = new FormData();
      const pola = {
        imie: wartosc('contact[name]'),
        email: wartosc('contact[email]'),
        telefon: wartosc('contact[phone]'),
        rodzaj_klienta: wartosc('contact[Rodzaj klienta]'),
        wzory: wartosc('contact[Wybrane wzory]'),
        powierzchnia: wartosc('contact[Powierzchnia ścian (m2)]'),
        liczba_plyt: wartosc('contact[Szacowana liczba płyt]'),
        uslugi,
        dostawa: wartosc('contact[Dostawa lub odbiór]'),
        kod: wartosc('contact[Kod pocztowy]'),
        miasto: wartosc('contact[Miejscowość]'),
        ulica: wartosc('contact[Ulica i numer]'),
        magazyn: wartosc('contact[Magazyn odbioru]'),
        nip: wartosc('contact[NIP]'),
        adres_taki_sam: wartosc('contact[Adres klienta]'),
        adres_kod: wartosc('contact[Adres klienta - kod pocztowy]'),
        adres_miasto: wartosc('contact[Adres klienta - miejscowość]'),
        adres_ulica: wartosc('contact[Adres klienta - ulica i numer]'),
        wiadomosc: wartosc('contact[body]'),
        zgoda: wartosc('contact[Zgoda na kontakt]'),
        jezyk: (document.documentElement.lang || 'pl').slice(0, 2),
        czas_ms: String(Math.round(performance.now() - this.otwarto)),
        strona_www: wartosc('strona_www'),
      };
      Object.entries(pola).forEach(([k, v]) => dane.append(k, v));
      this.pliki.forEach((plik) => dane.append('pliki', plik, plik.name));
      return dane;
    }

    async wyslijDoUslugi() {
      const d = this.przycisk.dataset;
      const napis = this.przycisk.textContent;
      this.wysylam = true;
      this.pokazBlad('');
      this.zablokujPrzycisk();
      let odpowiedz = null;
      let dane = {};
      try {
        // Token captchy w naglowku: usluga sprawdza go, zanim w ogole przeczyta pliki.
        odpowiedz = await fetch(`${this.usluga}/zapytanie`, {
          method: 'POST',
          headers: { 'X-Turnstile': this.captchaToken() },
          body: this.zbierz(),
        });
        dane = await odpowiedz.json().catch(() => ({}));
      } catch (blad) {
        odpowiedz = null;
      }
      if (odpowiedz && odpowiedz.ok && dane.ok) {
        const numer = dane.numer || '';
        const pole = this.formularz.querySelector('[data-quote-number]');
        if (pole) pole.value = numer;
        const zalaczniki = this.formularz.querySelector('[data-quote-attachments]');
        if (zalaczniki) {
          if (dane.plikow) zalaczniki.value = `${dane.plikow} - aplikacja Dizzplace Rezerwacje, zakladka Wyceny`;
          else if (this.pliki.length) zalaczniki.value = `${this.pliki.length} - NIE DOTARLY, poprosic klienta o maila`;
          else zalaczniki.value = 'brak';
        }
        if (numer) sessionStorage.setItem('dizz_wycena_numer', numer);
        this.krokPierwszyZrobiony = true;
        this.wyslijFormularz();
        return;
      }
      // Nieudana proba: przycisk wraca, token captchy jest jednorazowy.
      this.wysylam = false;
      this.przycisk.disabled = false;
      this.przycisk.textContent = napis;
      if (window.turnstile && this.captchaId !== undefined) window.turnstile.reset(this.captchaId);
      const kod = dane.blad;
      // Przy KAZDYM bledzie zostaje droga awaryjna: zwykly formularz bez plikow -
      // zapytanie nie moze przepasc przez captche, limit albo awarie uslugi.
      if (kod === 'captcha') this.pokazBlad(d.errCaptcha, true);
      else if (kod === 'limit') this.pokazBlad(d.errLimit, true);
      else if (kod === 'pola' || kod === 'za_szybko') this.pokazBlad(d.errFields, true);
      else if (kod === 'plik_za_duzy' || kod === 'zly_typ' || kod === 'za_duzo_plikow' || kod === 'za_duze') this.pokazBlad(d.errFile, true);
      else this.pokazBlad(d.errServer, true);
    }

    // Drugi krok idzie zdarzeniem wysylki (nasz handler je przepuszcza, bo
    // krokPierwszyZrobiony), wiec obsluguje je skrypt antyspamowy Shopify jak
    // kazdy formularz kontaktowy. Przycisk jest juz wylaczony, stad bez nadawcy.
    wyslijFormularz() {
      if (typeof this.formularz.requestSubmit === 'function') this.formularz.requestSubmit();
      else HTMLFormElement.prototype.submit.call(this.formularz);
    }

    wyslijBezPlikow() {
      const zalaczniki = this.formularz.querySelector('[data-quote-attachments]');
      if (zalaczniki) zalaczniki.value = this.pliki.length ? `${this.pliki.length} - NIE DOTARLY (blad uslugi), poprosic klienta o maila` : 'brak';
      this.krokPierwszyZrobiony = true;
      this.pokazBlad('');
      if (this.formularz.reportValidity()) {
        this.zablokujPrzycisk();
        this.wyslijFormularz();
      } else {
        this.krokPierwszyZrobiony = false;
      }
    }
  }

  customElements.define('project-quote', ProjectQuote);
})();
